import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { SharedCurrentUser } from "../../../shared/lib/types";
import RegisterOrLoginButtons from "../../../shared/components/app/RegisterOrLoginButtons";

const RegistrationRequiredModal = ({
  isOpen,
  onClose,
  currentUser,
}: {
  isOpen: boolean;
  onClose: () => void;
  currentUser: SharedCurrentUser;
}) => {
  const isApplicationing =
    currentUser?.is_temporary && currentUser?.personal_info_applicationing;

  const content = currentUser?.owned_business_entities?.current.is_active === false
    ? {
        title: "ご利用になるには事業者情報の掲載を再開してください",
        body: (
          <>
            事業者設定の「サービス利用設定」より事業者情報の掲載を再開できます。
          </>
        ),
      }
    : currentUser?.is_approved
      ? {
          title: "ご利用になるには事業者登録が必要です",
          body: (
            <>
              事業者登録が完了すると受発注サービスβ版のご利用が可能となります。
              <br />
              事業者登録がお済みの方はログインを行ってください。
            </>
          ),
        }
      : !currentUser
        ? {
            title: "ご利用になるには会員登録および事業者登録が必要です",
            body: (
              <>
                会員登録および事業者登録が完了すると受発注サービスβ版のご利用が可能となります。
                <br />
                会員登録および事業者登録がお済みの方はログインを行ってください。
              </>
            ),
          }
        : isApplicationing
          ? {
              title: "本人確認の審査中です",
              body: (
                <>
                  本人確認が完了するとすべてのコンテンツが利用可能となります。
                  <br />
                  本人確認の審査が完了するまでお待ちください。
                </>
              ),
            }
          : {
              title: "ご利用になるには本人確認および事業者登録が必要です",
              body: (
                <>
                  本人確認および事業者登録が完了すると受発注サービスβ版のご利用が可能となります。
                  <br />
                  本人確認および事業者登録がお済みの方はログインを行ってください。
                </>
              ),
            };
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl">
      <ModalOverlay />
      <ModalContent mx={2}>
        <ModalCloseButton />
        <ModalBody
          textAlign="center"
          pt={{ base: 16, md: 28 }}
          pb={{ base: 12, md: 20 }}
        >
          <VStack>
            <Text fontWeight="bold" fontSize={{ md: "2xl" }}>
              {content.title}
            </Text>
            <Text fontSize={{ base: "xs", md: "md" }} mt={{ base: 4, md: 6 }}>
              {content.body}
            </Text>
            {!currentUser?.is_approved && !isApplicationing && (
              <RegisterOrLoginButtons
                currentUser={currentUser}
                mt={{ base: 6, md: 10 }}
                fontSize={{ base: "sm", md: "md" }}
                loginButtonProps={{ variant: "outline" }}
              />
            )}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default RegistrationRequiredModal;
